document.addEventListener('DOMContentLoaded', function () {
  var materialModal = document.getElementById('materialModal')

  var materialBtn = document.querySelector('.material-modal-trigger');

  var materialSpan = document.querySelector('.material-modal-close');

  materialBtn.addEventListener('click', function () {
    materialModal.style.display = 'flex';
  });

  materialSpan.addEventListener('click', function () {
    materialModal.style.display = 'none';
  });

  window.addEventListener('click', function (event) {
    if (event.target === materialModal) {
      materialModal.style.display = 'none';
    }
  });
});
